
import { connect } from 'react-redux';
import { UGMALanding } from "./ugma-landing";
import {dwollaUpdate} from "../../../payment/actions";
import { updateUserNameRedux } from "../../../login/login/actions";

const mapDispatchToProps = dispatch => {
  return {
    updateUserNameRedux: (first_name, last_name) => { dispatch(updateUserNameRedux(first_name, last_name)) },
    dwollaUpdate: (data, index, username) => { dispatch(dwollaUpdate(data, index, username)) },
  };
}

const mapStateToProps = state => {
  return {
    client: state.client,
    user: state.user,
    dwolla: state.dwolla,
    token: state.user && state.user.token,
    acct_index: 0,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UGMALanding);
